export default __webpack_public_path__ + "static/media/custompackage.6a9d50a5.svg";